import { Pipe, PipeTransform } from '@angular/core';
import { RecurringTransaction } from '@app/modules/businesses/models/statements.models';

const WEEKLY_RECURRENCE_MAP = {
  MO: 'Monday',
  TU: 'Tuesday',
  WE: 'Wednesday',
  TH: 'Thursday',
  FR: 'Friday',
  SA: 'Saturday',
  SU: 'Sunday',
};

@Pipe({
  standalone: false,
  name: 'recurrenceSchedule',
})
export class RecurrenceSchedulePipe implements PipeTransform {
  transform(value: RecurringTransaction['recurrence'], ...args: unknown[]): unknown {
    if (!value || !value?.type) {
      return null;
    }

    if (value.type === 'weekly') {
      return WEEKLY_RECURRENCE_MAP[value.day];
    }

    if (value.type === 'monthly') {
      return `the ${value.day}${this.nth(Number(value.day))}`;
    }

    return null;
  }

  private nth(d: number) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
}
